import React, { useRef, useEffect } from 'react';
import { FaEye, FaPen, FaTrash } from 'react-icons/fa';

const ActionMenu = ({ onView, onEdit, onDelete, extraActions = [] }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);

  // Cerrar menú cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && !triggerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen]);

  const handleMenuItemClick = (callback) => {
    if (callback) callback();
    setIsOpen(false);
  };

  return (
    <div className="egreso-actions">
      <button
        ref={triggerRef}
        className="action-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title="Opciones"
        type="button"
      >
        ⋯
      </button>

      <div ref={menuRef} className={`action-menu ${isOpen ? 'active' : ''}`}>
        {onView && (
          <button
            className="action-menu-item"
            onClick={() => handleMenuItemClick(onView)}
            title="Ver recibo"
            type="button"
          >
            <FaEye /> Ver
          </button>
        )}

        {onEdit && (
          <button
            className="action-menu-item"
            onClick={() => handleMenuItemClick(onEdit)}
            title="Editar"
            type="button"
          >
            <FaPen /> Editar
          </button>
        )}

        {extraActions && extraActions.map((action, index) => (
          <button
            key={index}
            className="action-menu-item"
            onClick={() => handleMenuItemClick(action.onClick)}
            title={action.label}
            type="button"
          >
            {action.icon} {action.label}
          </button>
        ))}

        {onDelete && (
          <button
            className="action-menu-item delete"
            onClick={() => handleMenuItemClick(onDelete)}
            title="Eliminar"
            type="button"
          >
            <FaTrash /> Eliminar
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionMenu;
